import React from 'react';
import {Row, Col} from 'reactstrap';
import NodeItem from './NodeItem';

const NodeList = ({items}) => (
    <Row className="node-list">
        {items.map(({id, properties}) => (
            <Col key={id} xs={12} sm={6} md={4} lg={3}>
                <NodeItem id={id} properties={properties} />
            </Col>
        ))}
    </Row>
);

export default NodeList;
